import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Config } from '../../contabilidad/config/config';
@Injectable({
  providedIn: 'root'
})
export class EjercicioService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {

  }
  getEjercicios(gral_emp_id: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/get/ejercicio/' + gral_emp_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  cerrarEjercicio(id_ejercicio: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/cerrar/ejercicio/' + id_ejercicio + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  reabrirEjercicio(id_ejercicio: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/reabrir/ejercicio/' + id_ejercicio + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  crearEjercicio(gral_emp_id: number, ejercicio: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/crear/ejercicio/' + gral_emp_id + '/' + ejercicio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  cerrarPeriodo(id_periodo: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/cerrar/periodo/' + id_periodo + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

    abrirPeriodo(id_periodo: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/abrir/periodo/' + id_periodo + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

///baja/pol/cierre/periodo/{id}/{idGralUsr}
    bajaPolizaCierrePeriodo(id: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/anio-periodo/baja/pol/cierre/periodo/' + id + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
